export default {
  currentPage(state, value) {
    return (state.currentPage = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  paginationTotal(state, value) {
    return (state.total = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  tableLoading(state, value) {
    return (state.tableLoading = value);
  },

  myAppraisals(state, value) {
    return (state.myAppraisals = value);
  },

  appraisalApproval(state, value) {
    return (state.appraisalApproval = value);
  },

  appraisalsById(state, value) {
    return (state.appraisalsById = value);
  },

  setSelectedRow(state, value) {
    return (state.selectedRow = value);
  },
};
